module.exports = __webpack_public_path__ + "static/media/baja-y-desguace-de-vehiculos.b7ead16e.png";